/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Modal } from "components/views/modal/Modal"
import { Body, Button, Container, FlexContainer, H2, Stack } from "@carrotfertility/carotene"
import { IlloDocAndCoins } from "components/views/atoms/Illustrations"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import Locations from "components/views/home/navigation"
import { useHistory } from "react-router-dom"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"
import { FormattedMessage, useIntl } from "react-intl"

export function EraseYourAnswersModal({ onExit }): JSX.Element {
  const history = useHistory()
  const handleQleResetClick = (): void => history.push(Locations.Home.QleEnrollmentActive)
  const intl = useIntl()

  return (
    <EmployeeOnlyModalContainer onClose={onExit}>
      <Modal
        titleText={intl.formatMessage({ defaultMessage: "Erase existing answers" })}
        onExit={onExit}
        underlayClickExits={false}
      >
        <Container width="100%" paddingLeftRight="huge" stack="huge">
          <FlexContainer justifyContent="center" padding="none" stack="medium">
            <IlloDocAndCoins />
          </FlexContainer>
          <Stack direction="column" spacing="tiny">
            <H2 variant="primary">
              <FormattedMessage defaultMessage="Erase existing answers?" />
            </H2>
            <Body color="black80">
              <FormattedMessage defaultMessage="All of the insurance information you provided previously will be deleted so that you can make corrections." />
            </Body>
            <Stack alignItems="center" direction={["column", null, "row"]} spacing="tiny" justifyContent="center">
              <Button variant="secondary" onClick={onExit}>
                <FormattedMessage defaultMessage="No, I don't need to update" />
              </Button>
              <ButtonPrimary type="submit" onClick={handleQleResetClick}>
                <FormattedMessage defaultMessage="Yes, I need to update" />
              </ButtonPrimary>
            </Stack>
          </Stack>
        </Container>
      </Modal>
    </EmployeeOnlyModalContainer>
  )
}
